import { Component } from "@angular/core";
import { ConfigService, Filters, OneOf } from "../../../common";
import { ManifestFiltersModel } from "./manifest-filters.model";

@Component({
  selector: "manifest-filters",
  templateUrl: "./manifest-filters.html",
  standalone: false,
})
export class ManifestFilters implements Filters {
  model: ManifestFiltersModel;
  wasteTypeOptions: string[];
  sortOptions: string[];

  constructor(private configService: ConfigService) {
    this.model = new ManifestFiltersModel();

    this.configService.get().subscribe((config) => {
      this.wasteTypeOptions = config.wasteTypeOptions;
      this.sortOptions = config.manifestSortingOptions;
    });
  }

  public get state(): string {
    return this.model.getState();
  }

  public set state(value: string) {
    this.model = new ManifestFiltersModel(value);

    this.model.type = OneOf(this.model.type, this.wasteTypeOptions);
    this.model.sortBy = OneOf(this.model.sortBy, this.sortOptions);
  }

  reset() {
    this.model = new ManifestFiltersModel();
  }
}
